import React, { useState } from "react";

export default function StakeDigitSelector() {
  const [selectedStake, setSelectedStake] = useState(0);
  const [digitStakes, setDigitStakes] = useState({});

  const stakeButtons = [5, 10, 50, 100, 200, 500, 1000, 5000];
  const digits = Array.from({ length: 10 }, (_, i) => i);

  const handleDigitClick = (digit) => {
    if (!selectedStake) return;

    setDigitStakes((prev) => ({
      ...prev,
      [digit]: (prev[digit] || 0) + selectedStake,
    }));
  };

  return (
    <div>
      <h3>Select Stake:</h3>
      <div>
        {stakeButtons.map((stake) => (
          <button
            key={stake}
            onClick={() => setSelectedStake(stake)}
            style={{
              margin: "5px",
              background: selectedStake === stake ? "green" : "blue",
              color: "white",
              padding: "10px",
            }}
          >
            {stake}
          </button>
        ))}
      </div>

      <h3>Select Digit:</h3>
      <div>
        {digits.map((digit) => (
          <button
            key={digit}
            onClick={() => handleDigitClick(digit)}
            style={{
              margin: "5px",
              padding: "10px",
              background: "#eee",
            }}
          >
            {digit} ({digitStakes[digit] || 0})
          </button>
        ))}
      </div>
    </div>
  );
}
